import React from 'react';
import CardHeader from '../shared/CardHeader';
import Table from 'components/Table';
import PdpNotice from 'components/PdpNotice';
import {fetchSuperTable} from 'state/card/cardService';
import {cancelRequest} from 'utilities/Request';
import get from 'lodash/get';
import mapKeys from 'lodash/mapKeys';
import camelCase from 'lodash/camelCase';
import styles from './SuperTable.css?module';

const mapStyles = style => mapKeys(style, (val, key) => camelCase(key));

class SuperTable extends React.Component {
  state = {table: null};

  componentDidMount() {
    this.fetch(this.props);
  }

  componentWillUnmount() {
    this.cancelFetch();
  }

  UNSAFE_componentWillReceiveProps(next) {
    if (this.props.cardId !== next.cardId) {
      this.fetch(next);
    }
  }

  cancelFetch() {
    cancelRequest(this.request);
  }

  fetch({cardId, maxRows}) {
    this.cancelFetch();

    this.request = fetchSuperTable(cardId, {
      limit: maxRows,
    });

    this.request.then(
      response => {
        this.setState({
          table: response.rows,
        });
      },
      e => {
        if (e.statusText === 'abort') return;
        this.setState({
          table: null,
        });
      }
    );
  }

  numberOfColumns = () => {
    const tableColumns = this.state.table
      ? this.state.table.data.numColumns
      : 0;
    return Math.min(this.props.maxColumns, tableColumns);
  };

  numberOfRows = () => {
    const tableRows = this.state.table ? this.state.table.data.numRows : 0;
    return Math.min(this.props.maxRows, tableRows);
  };

  getHeaderAt = column =>
    this.state.table ? this.state.table.data.columns[column] : null;

  getCellAt = (row, column) =>
    this.state.table ? this.state.table.data.rows[row][column] : null;

  getCellStyleAt = (row, column) => {
    const cellStyles = get(this.state, ['table', 'cellStyles', column, row]);
    return cellStyles ? mapStyles(cellStyles) : null;
  };

  render() {
    return (
      <div className={styles.tableContainer}>
        <Table
          style={{margin: 'auto'}}
          numberOfColumns={this.numberOfColumns}
          numberOfRows={this.numberOfRows}
          getHeaderAt={this.getHeaderAt}
          getCellAt={this.getCellAt}
          getCellStyleAt={this.getCellStyleAt}
        />
      </div>
    );
  }
}

SuperTable.defaultProps = {
  maxColumns: Infinity,
  maxRows: Infinity,
};

export const CardSuperTable = ({card, cardId}) => (
  <div className={styles.superTable}>
    <CardHeader card={card} />
    <SuperTable cardId={cardId} maxColumns={2} maxRows={5} showHeader={true} />
    <PdpNotice cardId={cardId} />
  </div>
);

export const DetailsSuperTable = ({cardId}) => (
  <div className={styles.superTable}>
    <SuperTable cardId={cardId} />
    <PdpNotice cardId={cardId} />
  </div>
);
